import { TYPOGRAPHY } from './Typographys';

export const EMAIL_RULES = [
  { required: true, message: 'Please enter your email!' },
  { type: 'email', message: 'Please enter a valid email address!' },
];

export const PASSWORD_RULES = [
  { required: true, message: 'Please enter your password!' },
  {
    min: 8,
    pattern:
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?#&])[A-Za-z\d@$!%*?#&]{8,}$/,
    message:
      'Password must be at least 8 characters long, include a special symbol and a capital letter.',
  },
];

export const PASSWORD_WITHOUT_MESSAGE_RULES = [
  { required: true, message: 'Please enter your password!' },
];
export const CONFORM_PASSWORD_RULES = [
  { required: true, message: 'Please enter your password!' },
  {
    min: 8,
    pattern:
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?#&])[A-Za-z\d@$!%*?#&]{8,}$/,
    message:
      'Password must be at least 8 characters long, include a special symbol and a capital letter.',
  },
];

export const NAME_RULES = [
  { required: true, message: 'Please enter your full name!' },
  {
    pattern: /^[a-zA-Z\s]+$/,
    message: 'Full name must only contain letters!',
  },
];

export const PHONE_NUMBER_RULES = [
  { required: true, message: 'Please enter your phone number!' },
  {
    pattern: /^[0-9]{10}$/,
    message: 'Phone number must be 10 digits long!',
  },
];

export const CHECKBOX_RULES = [
  {
    validator: (_, value) =>
      value
        ? Promise.resolve()
        : Promise.reject(
            new Error('You must accept the terms and conditions!')
          ),
  },
];

export const PASSWORD_STRING_CONFIG = {
  text: 'Password must be at least 8 characters long, include a special symbol and a capital letter.',
  className: '!mb-2 !text-purple-600 !text-[12px]',
  type: TYPOGRAPHY.PARA,
};
